import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/user-list';
import ListGroupHeaderComponent from "./components/user-group-list-header";
import TListGroupHeader1Component from "./components/user-group-t-list-header-1";
import ViewComponent from './components/user-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from "./components/user-form-new";
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";

export default class UserCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        let res = '';
        const userId = !!customFieldsData[this.customField.id] ? customFieldsData[this.customField.id] : null;

        const user = gd.session.users.get(userId);
        if (user) res = user.name;

        return res;
    }

    listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id] ? i.item.customFieldsData[this.customField.id] : null;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => {
                    let res = '';
                    if (i.item.customFieldsData[this.customField.id]){
                        const user = gd.session.users.get(i.item.customFieldsData[this.customField.id]);
                        if (user) res = user.name;
                    }
                    return res;
                }
            ],
            directions: ['asc', sort]
        }
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get TListGroupHeader1Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get TListGroupHeader2Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return mapByUserName(gd.companyId, value);
    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }

}